import { APIConnector, Settings } from "../base";

const apiConnector = new APIConnector({ timeout: 200000 });

export default class GenerateExcelConfig {
	static get base() {
		return Settings.server + "/generateExcel";
	}

	static get endpoint() {
		return GenerateExcelConfig.base;
	}
	static get endpointById() {
		return `${GenerateExcelConfig.base}/by-id`;
	}

	static get baseDomain() {
		return Settings.serverDomain;
	}

	static get endpointTmp() {
		return `${GenerateExcelConfig.baseDomain}/tmp`;
	}

	static get endpointCompaniesNotRegistered() {
		return `${GenerateExcelConfig.base}/companies-not-registered`;
	}

	static get endpointAffiliatesPerCity() {
		return `${GenerateExcelConfig.base}/affiliates-per-city`;
	}

	static get APIConnector() {
		return apiConnector;
	}
}



// WEBPACK FOOTER //
// ./src/provider/GenerateExcel/GenerateExcelConfig.js